const _ = require('underscore');
const Backbone = require('backbone');
const OptionGroupModel = require('models/store/client/product/optiongroup');
module.exports = Backbone.Collection.extend({
	model: OptionGroupModel,

	initialize: function() {
		this.on('optionGroup:changed', this._optionGroupChanged, this);
	},

	/**
	 * getRequiredGroups - Shortcut for filtering required option groups
	 * @return {Array} - Options Groups that are required
	 */
	getRequiredGroups: function() {
		return this.where({
			required: true
		});
	},

	/**
	 * getConfiguredOptions - Shortcut for filter configured option groups
	 * @return {Array} - Option Groups with status of `configured` set to true
	 */
	getConfiguredOptions: function() {
		return this.where({
			configured: true
		});
	},

	/**
	 * getSelectedOptions - Find all selected priced options
	 * @return {Array} Selected Priced Options
	 */
	getSelectedOptions: function() {
		var found = _.reduce(
			this.models,
			function(memo, value, key, list) {
				var selectedOption = list[key].getSelected();
				if (selectedOption.length) {
					memo.push(selectedOption);
				}
				return memo;
			},
			[]
		);
		return _.flatten(found) || [];
	},

	/**
	 * getDecoratedSelectedOptions - Shortcut to get the json of the selected priced options
	 * @return {Array} Actively selected ids
	 */
	getDecoratedSelectedOptions: function() {
		return _.map(this.getSelectedOptions(), function(i) {
			if (i.get('keyCode') !== undefined) {
				return {
					pricedOptionId: i.get('id'),
					keyCode: i.get('keyCode')
				};
			}
			return {
				pricedOptionId: i.get('id'),
				keyCode: null
			};
		});
	},

	/**
	 * getSelectedOptionsPrice - Sum together all of the active priced options
	 * @return {Number} Sum of configuration options
	 */
	getSelectedOptionsPrice: function() {
		return _.reduce(
			this.getSelectedOptions(),
			function(memo, option) {
				if (!option.get('price')) {
					return memo;
				}
				return memo + option.get('price');
			},
			0
		);
	},

	/**
	 * _optionGroupChanged - Callback for option groups changing
	 * @private
	 */
	_optionGroupChanged: function() {
		Backbone.trigger('optionList:updated', this.getDecoratedSelectedOptions());
		this.trigger('optionGroups:updated');
	}
});
